export const API_CALL = 'API_CALL'
export const API_CALL_FAILURE = 'API_CALL_FAILURE'
export const SOCKET_EVENT = 'SOCKET_EVENT'
